(ns minorodata.dependency-graph.api
  "Fetches the dependency graph from `/api/dependency-graph/live`. Without an
   anchor it returns the FULL graph (the default \"Pipelines\" tab); with an
   `anchor_id`/`anchor_type` it returns the subpipeline around that node, which
   we render in a separate tab using the same nested-ELK layout."
  (:require
   [minorodata.dependency-graph.events :refer [dag-id]]
   [minorodata.pipeline-dag.timing :as timing]
   [minorodata.sandbox.model :refer [->pipeline-transform]]
   [mold-http.core :refer [reg-event-http]]))


(defn fetch-graph-request [_ [{:keys [tab-id anchor-id anchor-type restore?]}]]
  (timing/start! :fetch)
  {:http-xhrio
   {:url       (if anchor-id
                 (str "/api/dependency-graph/live"
                      "?anchor_id="   (js/encodeURIComponent anchor-id)
                      "&anchor_type=" (js/encodeURIComponent anchor-type))
                 "/api/dependency-graph/live")
    :cb-params {:tab-id (or tab-id dag-id) :restore? restore?}}})

(defn fetch-graph-callback [_ [error resp {:keys [tab-id restore?]}]]
  (cond
    ;; A persisted tab whose subpipeline no longer exists: drop it quietly rather
    ;; than nagging the user about a tab they didn't just open.
    (and (some? error) restore?)
    {:dispatch [:dependency-graph.events/close-tab tab-id]}

    (some? error)
    {:dispatch-n [[:app.events/add-snack :error "Failed to fetch the dependency graph"]
                  [:app.api/log :error "Failed to fetch the dependency graph" error]]}

    :else
    {:dispatch [:dependency-graph.events/receive-graph (assoc resp :tab-id tab-id)]}))

(reg-event-http
 :dependency-graph.api/fetch-graph
 fetch-graph-request
 fetch-graph-callback)


;; Tags aren't on the live-graph nodes and the groups list doesn't nest
;; transforms (those load per-group, lazily), so the tag filter has no data
;; until we pull every transform with its tags here. An empty query + huge page
;; returns them all; `->pipeline-transform` stores them as `pipeline-transform`
;; entities (tags as a plain string vector), which `:dependency-graph.subs/transform-tags`
;; turns into the `transform-id -> tags` lookup used for filtering.
(defn fetch-transforms-request [_ _]
  {:http-xhrio
   {:id     :dependency-graph-transforms-request
    :url    "/api/transformations/search"
    :method :POST
    :params {:query       ""
             :specificity "everything"
             :filters     {:type "transform"}
             :pagination  {:page 0 :items-per-page 999999}}}})

(defn fetch-transforms-callback [{:keys [db]} [error resp]]
  (if (some? error)
    {:dispatch [:app.api/log :error "Failed to fetch transforms for the dependency-graph tag filter" error]}
    ;; The tag filter runs at layout time off these entities, so if a tag filter is
    ;; already active (e.g. persisted across a reload) the graph was laid out before
    ;; tags existed — relayout now that they do so the filter actually applies.
    {:dispatch-n (cond-> [[:pipeline-transform/add-many
                           (mapv ->pipeline-transform (get-in resp [:transforms :data]))]]
                   (seq (get-in db [:dependency-graph :filters :tags]))
                   (conj [:dependency-graph.events/layout-all]))}))

(reg-event-http
 :dependency-graph.api/fetch-transforms
 fetch-transforms-request
 fetch-transforms-callback)
